import React from 'react'

export const PagoExitosoExistente = (data) => {
    console.log(data);
  const {topup_amount,mdn, approval_code} = data;
  return (
    <div className='contenedorTicket'>
        <div className='parte1'>
            <div className='iconoExito'></div>
            <div className='tituloTicket'>¡Pago realizado!</div>
            
            <div className='cantidadPagada'>${topup_amount}.00</div>
            <p>Tu pago para esta promoción ya habia sido realizado en línea</p>
        </div>
        <div className='parte2'>
            <div className='contNum'>
                <span className='icoCel'></span>
                <span className='textoIco'>{mdn}</span>
            </div>
            <div className='contNum2'>
                <span>Código de aprobación: </span>
                <span >{approval_code}</span>
            </div>
        </div>
    </div>
  )
}
